export default "__VITE_ASSET__mwIKQOkk__"